import React from 'react';
import { Badge, Box, IconButton, Typography } from '@mui/material';
import { NotificationsNone as BellIcon } from '@mui/icons-material';
import { HeaderProfileButton } from '../profile';

interface AppHeaderProps {
  title?: string;
  username?: string;
  /** Подпись справа от профиля: «Аптека №…», «Склад …» и т.п. */
  locationText?: string | null;
  /** Колокольчик показывается только если передан обработчик */
  onNotificationsClick?: () => void;
  unreadNotificationsCount?: number;
  onProfileClick: () => void;
  isProfileSelected?: boolean;
}

const Divider = () => <Box sx={{ width: '1px', height: 16, bgcolor: '#e4e4e7' }} />;

/**
 * Единая шапка для /admin и /dashboard: заголовок страницы слева,
 * справа - уведомления, профиль (аватар + имя) и место работы.
 */
const AppHeader: React.FC<AppHeaderProps> = ({
  title,
  username,
  locationText,
  onNotificationsClick,
  unreadNotificationsCount = 0,
  onProfileClick,
  isProfileSelected = false
}) => (
  <Box
    sx={{
      height: 48,
      flexShrink: 0,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      px: 4,
      borderBottom: '1px solid #e4e4e7',
      bgcolor: 'white'
    }}
  >
    <Typography variant="h6" sx={{ color: '#18181b', fontWeight: 600, fontSize: '1.25rem' }}>
      {title || 'Панель управления'}
    </Typography>

    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      {onNotificationsClick && (
        <>
          <IconButton
            size="small"
            onClick={onNotificationsClick}
            title="Уведомления"
            sx={{
              color: unreadNotificationsCount > 0 ? '#ef4444' : '#71717a',
              '&:hover': { color: '#18181b', bgcolor: '#f4f4f5' }
            }}
          >
            <Badge badgeContent={unreadNotificationsCount} color="error" max={99}>
              <BellIcon sx={{ fontSize: 20 }} />
            </Badge>
          </IconButton>
          <Divider />
        </>
      )}

      <HeaderProfileButton username={username} onClick={onProfileClick} isSelected={isProfileSelected} />

      {locationText && (
        <>
          <Divider />
          <Typography sx={{ fontSize: '0.875rem', fontWeight: 500, color: '#18181b' }}>
            {locationText}
          </Typography>
        </>
      )}
    </Box>
  </Box>
);

export default AppHeader;
